import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { getAverias } from 'src/store/actions/api'

export const useAverias = () => {
  const dispatch = useDispatch()

  const averias = useSelector(s => s.api.averias)
  const isLoaded = !!averias

  useEffect(() => {
    if (!isLoaded) {
      dispatch(getAverias())
    }
  }, [dispatch, isLoaded])

  return {
    averias,
    averiasList: (averias && averias.value && averias.value.listado) || []
  }
}
